import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';

export const Menu = styled.div`
    @media ${MediaQueries.smallAndUp} {
        width: 300px;
    }
`;
